import React, { useEffect, useRef, useState } from "react";
import styles from "./GlobalTech.module.css";
import { Button } from "react-bootstrap";
import globalTechbg from "../../Assests/Images/newWorldMap.png";
import globalteam from "../../Assests/Images/globalteam.jpg";
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import worldMap from "../../Assests/Images/world-map.jpg";
import greenLine from "../../Assests/Images/green-line.svg";

function GlobalTech() {
  const navigate = useNavigate();
  const [isMapVisible, setIsMapVisible] = useState(false);
  const mapSectionRef = useRef(null);

  const toggleDropdown = () => {
    navigate('/contact');
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsMapVisible(entry.isIntersecting);
      },
      { threshold: 0.2 } 
    );

    if (mapSectionRef.current) {
      observer.observe(mapSectionRef.current);
    }

    return () => {
      if (mapSectionRef.current) {
        observer.unobserve(mapSectionRef.current);
      }
    };
  }, []);

  return (
    <div>
      <section className={styles.globalTechSectionContainer}>
        <div className={styles.globalTechOverviewSection}>
          <div>
            <div className={styles.globalTechOverlay}>
              <div className={styles.overlaySection}>
                <div className={styles.globalTeamContent}>
                  <img src={globalteam} alt="Global Team" className={styles.globalTeamImage} />
                </div>
                <div className={styles.globalTechText}>
                  Our team of experts combines years of experience in
                  procurement, logistics, and supply chain management. Led by
                  industry professionals, we bring a solutions-driven approach
                  to every client engagement
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className={styles.ourAgentSection}>
        <section className={styles.ourAgentContainer}>
          <div className={styles.header}>
            <p className={styles.heading}>Our agents, partners and offices are strategically located across various continents</p>
          </div>
          <p className={styles.ourAgentDescription}>
            Hyproc International – Your global partner in procurement excellence Partner with us and experience streamlined global supply
          </p>
          
          <div className={styles.worldMapSection} ref={mapSectionRef}>
            <div className={`${styles.worldMapContainer} ${isMapVisible ? styles.mapVisible : ''}`}>
              <img src={worldMap} alt="Global Presence" className={styles.worldMapImage} />
              
      <div className={`${styles.markerContainer} ${styles.markerNorthAmerica} ${isMapVisible ? styles.markerVisible : ''}`}>
      <div className={styles.regionName}>North America</div>
     <img src={greenLine} alt="Line" className={styles.greenLine} />
     <div className={styles.locationMarker}></div>
        </div>

              <div className={`${styles.markerContainer} ${styles.markerEurope} ${isMapVisible ? styles.markerVisible : ''}`} style={{ animationDelay: '0.1s' }}>
                <div className={styles.regionName}>Europe</div>
                <img src={greenLine} alt="Line" className={styles.greenLine} />
                <div className={styles.locationMarker}></div>
              </div>

              <div className={`${styles.markerContainer} ${styles.markerMiddleEast} ${isMapVisible ? styles.markerVisible : ''}`} style={{ animationDelay: '0.1s' }}>
                <div className={styles.regionName}>Middle East</div>
                <img src={greenLine} alt="Line" className={styles.greenLine} />
                <div className={styles.locationMarker}></div>
              </div>

              <div className={`${styles.markerContainer} ${styles.markerAsia} ${isMapVisible ? styles.markerVisible : ''}`} style={{ animationDelay: '0.2s' }}>
                <div className={styles.regionName}>Asia</div>
                <img src={greenLine} alt="Line" className={styles.greenLine} />
               <div className={styles.locationMarker}></div>
              </div>

              <div className={`${styles.markerContainer} ${styles.markerAfrica} ${isMapVisible ? styles.markerVisible : ''}`} style={{ animationDelay: '0.3s' }}>
                <div className={styles.regionName}>Africa</div>
                <img src={greenLine} alt="Line" className={styles.greenLine} />
                <div className={styles.locationMarker}></div>
              </div>
            </div>
          </div>
        </section>
      </div>

      
    </div>

    
  );
}

export default GlobalTech;
